(() => {
  const dialog = document.querySelector('[data-cookie-dialog]');
  const triggers = [...document.querySelectorAll('[data-cookie-open]')];
  if (!dialog || !triggers.length) return;
  const status = dialog.querySelector('[data-cookie-status]');
  const inputs = [...dialog.querySelectorAll('[data-consent-purpose]')];
  let loading;
  const api = () => {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (!loading) loading = new Promise((resolve, reject) => {
      if (!window.Shopify?.loadFeatures) { reject(new Error('Privacy API unavailable')); return; }
      const timer = setTimeout(() => reject(new Error('Privacy API timeout')), 12000);
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
        clearTimeout(timer);
        if (error || !window.Shopify.customerPrivacy) { reject(new Error('Privacy API unavailable')); return; }
        resolve(window.Shopify.customerPrivacy);
      });
    }).catch(error => { loading = null; throw error; });
    return loading;
  };
  const sync = privacy => {
    const consent = privacy.currentVisitorConsent();
    inputs.forEach(input => { input.checked = consent[input.dataset.consentPurpose] === 'yes'; });
  };
  const buttons = [...dialog.querySelectorAll('[data-cookie-save],[data-cookie-reject],[data-sale-optout]')];
  const record = async (values, close = true) => {
    buttons.forEach(button => { button.disabled = true; });
    status.textContent = '';
    try {
      const privacy = await api();
      await new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error('Consent save timeout')), 12000);
        privacy.setTrackingConsent(values, () => { clearTimeout(timer); resolve(); });
      });
      const recorded = privacy.currentVisitorConsent();
      if (Object.entries(values).some(([purpose, value]) => recorded[purpose] !== (value ? 'yes' : 'no'))) throw new Error('Consent not recorded');
      sync(privacy);
      status.textContent = dialog.dataset.saved;
      if (close) dialog.close();
    } catch {
      status.textContent = dialog.dataset.error;
    } finally {
      buttons.forEach(button => { button.disabled = false; });
    }
  };
  triggers.forEach(trigger => {
    trigger.hidden = false;
    trigger.addEventListener('click', async () => {
      status.textContent = '';
      dialog.showModal();
      [...buttons, ...inputs].forEach(control => { control.disabled = true; });
      try { sync(await api()); } catch { status.textContent = dialog.dataset.error; }
      finally { [...buttons, ...inputs].forEach(control => { control.disabled = false; }); }
    });
  });
  dialog.querySelector('[data-cookie-close]').addEventListener('click', () => dialog.close());
  dialog.querySelector('[data-cookie-save]').addEventListener('click', () => record(Object.fromEntries(inputs.map(input => [input.dataset.consentPurpose, input.checked]))));
  dialog.querySelector('[data-cookie-reject]').addEventListener('click', () => record({analytics: false, marketing: false, preferences: false}));
  dialog.querySelector('[data-sale-optout]').addEventListener('click', () => record({sale_of_data: false}, false));
  document.addEventListener('visitorConsentCollected', () => { if (dialog.open && window.Shopify?.customerPrivacy) sync(window.Shopify.customerPrivacy); });
})();
